import { Flex } from '@chakra-ui/react'
import { FaAt, FaMobile, FaQrcode } from 'react-icons/fa'
import { iConvite } from '../../../../../../interfaces'
import { CircleText } from '../CircleText'

interface iBoxProps {
  convites: iConvite[]
  linkAberto?: number
  tipo: 'email' | 'qrcode' | 'usuario'
}

export const BoxCount: React.FC<iBoxProps> = ({ convites, tipo, linkAberto, children }) => {
  return (
        <Flex width={'50%'} justifyContent='space-between' padding={'1rem'} flexDir={'column'} border={'2px solid var(--Gray4)'} borderRadius={'24px'} alignItems={'center'} maxHeight={'190px'}>
            <Flex marginBottom={'1rem'} justifyContent={'center'} alignItems={'center'} height='100%'>
                        <Flex color={'black'} flexDir={'column'} alignItems={'center'} maxHeight={'100px'} >
                    {
                        tipo === 'email'
                          ? <FaAt size={40} />
                          : tipo === 'qrcode'
                            ? <FaQrcode size={40} />
                            : <FaMobile size={40} />
                    }
                    <span style={{ marginTop: '.5rem', fontWeight: '700' }}>{tipo === 'email' ? 'E-mail' : tipo === 'qrcode' ? 'Link aberto' : 'Usuários'}</span>
                </Flex>
                <Flex marginLeft={'.8rem'} gap={'.3rem 0rem'} flexDirection={'column'}>
                    {
                        (tipo !== 'qrcode') && (
                            <>
                                <CircleText
                                    fontsize='16px'
                                    varColorCircle='Rosa'
                                    varColorText='Preto'
                                    titulo={convites.filter(e => e.status === 'Enviado').length}
                                >Convites enviados
                                </CircleText>

                                <CircleText
                                    fontsize='16px'
                                    varColorCircle='c4'
                                    varColorText='Preto'
                                    titulo={convites.filter(e => e.status === 'Não enviado').length}
                                >Convites a enviar
                                </CircleText>
                            </>
                        )

                    }

                    {
                        (tipo === 'email') && (
                            <CircleText
                                fontsize='16px'
                                varColorCircle='secundario5'
                                varColorText='Preto'
                                titulo={convites.filter(e => e.status === 'Erro').length}
                            >Convites com erro
                            </CircleText>
                        )
                    }

                    {
                        (tipo === 'qrcode') && (
                            <CircleText
                                fontsize='16px'
                                varColorCircle='v2'
                                varColorText='Preto'
                                titulo={linkAberto ?? 0}
                            >Respostas
                            </CircleText>
                        )
                    }
                </Flex>
            </Flex>
            <Flex justifyContent={'center'} height='fit-content' alignItems={'end'}>
                {children}
            </Flex>
        </Flex>
  )
}
